import { CardProgressBarWrapper } from '@routes/sidebar/___shared___/components/card-progress-bar/styled.tsx';
import styled from 'styled-components';

export const CardActionsWrapper = styled.div`
    display: flex;
    padding: var(--spacing-sm, 16px) var(--spacing-sm, 16px) 0px 0px;
    flex-direction: column;
    align-items: flex-end;
    gap: var(--spacing-sm, 16px);
`;

export const CardActionsButtons = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;
    align-self: stretch;
    ${CardProgressBarWrapper} {
        width: 174px;
    }

    .ant-btn-icon {
        margin-top: 6px;
    }
    .learning-action-btn {
        width: 162px;
    }
`;

export const DetailsToggler = styled.div`
    display: none;
`;
